import { isDefined } from '@sgme/fp';
import { useIntlContext } from 'contexts/intl/intlContext';
import { de, fr, it, ja } from 'date-fns/locale';
import type { IntlKey } from 'locales';
import { last } from 'lodash-es';

export const useSPIntl = () => {
  const res = useIntlContext();

  return {
    ...res,
    newCollator: () => new Intl.Collator(res.locale),
    concatFormatMessage: (...segments: (string | null | undefined)[]) =>
      res.formatMessage({
        id: segments.filter(isDefined).join('.') as IntlKey,
        defaultMessage: last(segments) ?? '',
      }),
  };
};

function getDateFnLocale(code: string) {
  switch (code) {
    case 'de':
      return de;
    case 'fr':
      return fr;
    case 'it':
      return it;
    case 'ja':
      return ja;
    default:
      return undefined;
  }
}

export function useDateFnLocale() {
  const { locale: code } = useSPIntl();
  return getDateFnLocale(code);
}
